import { render, staticRenderFns } from "./rfq-tab-audit.vue?vue&type=template&id=3b9fd580"
import script from "./rfq-tab-audit.vue?vue&type=script&lang=js"
export * from "./rfq-tab-audit.vue?vue&type=script&lang=js"
import style0 from "./rfq-tab-audit.vue?vue&type=style&index=0&id=3b9fd580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports